module.exports = __webpack_public_path__ + "img/MVR-Palliative-Care.38779e0b.jpg";